import { takeLatest, call, put, select } from 'redux-saga/effects';

// Services
import { schemasApi } from 'services/apiDigitalTicket/schemas';

// Actions
import * as DialogsActions from 'store/ducks/dialogs/actions';
import * as SnackbarsActions from 'store/ducks/snackbars/actions';

// Constants
import { errorMessagersList } from 'helpers/errorMessagers';

import * as SchemasActions from './actions';
import { SchemasTypes } from './types';

function* list({
  payload,
}: ReturnType<typeof SchemasActions.listSchemaRequest>): any {
  try {
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(schemasApi.list, {
      params: { transportOperatorId: transportOperator.id },
    });

    if (response.status === 200) {
      yield put(
        SchemasActions.listSchemaSuccess({ schemaList: response.data }),
      );
      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('schemas - list - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(SchemasActions.listSchemaFailure());
    yield put(DialogsActions.setClose());
  }
}

// eslint-disable-next-line import/prefer-default-export
export const schemasSagas = [
  takeLatest(SchemasTypes.LIST_SCHEMA_REQUEST, list),
];
